module.exports = __webpack_public_path__ + "img/bathroom.a95066db.webp";